export default __webpack_public_path__ + "static/media/TVS_logo.c205ef42.svg";